import React, { Component, lazy, Suspense } from 'react';
import Modal from 'rc-dialog';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';

import { ModalProps } from 'stores/ModalStore';
import EmailViewModalStore from 'stores/Modals/EmailViewModalStore';

import Button from 'components/Button/Button';
import TextField from 'components/Form/Fields/Text/TextField';
import ModalHeader from 'components/Modals/Components/ModalHeader/ModalHeader';
import ModalBody from 'components/Modals/Components/ModalBody/ModalBody';
import ModalControls from 'components/Modals/Components/ModalControls/ModalControls';
import Spinner from 'components/Spinner/Spinner';
import { Label } from 'components/Form/Label/Label';

import style from './EmailViewModal.module.scss';

const RichTextEditor = lazy(() =>
  import('components/Form/Fields/RichTextEditor/RichTextEditor'),
);

interface Props extends ModalProps {
  id: string;
}

@observer
class EmailViewModal extends Component<Props> {
  private _store = new EmailViewModalStore(this.props.id);

  async componentDidMount() {
    await this._store.init();
  }

  render() {
    const { email } = this._store;

    return (
      <Modal
        {...this.props}
        className={style.modal}
        destroyOnClose
        animation="zoom"
        maskAnimation="fade"
        visible
      >
        {this._store.isLoading && <Spinner contain />}

        <ModalHeader>
          <FormattedMessage id="modal.email.view.title" />
        </ModalHeader>

        <ModalBody>
          <div>
            <div className={style.form__field}>
              <Label textId="title.email.to" />
              <TextField value={email?.to || ''} disabled />
            </div>
            <div className={style.form__field}>
              <Label textId="title.email.subject" />
              <TextField value={email?.subject || ''} disabled />
            </div>
            <div className={style.form__field}>
              <Label textId="title.email.message" />
              <Suspense fallback={<Spinner contain />}>
                <RichTextEditor value={email?.message || ''} readOnly />
              </Suspense>
            </div>
          </div>
        </ModalBody>

        <ModalControls className={style.controls}>
          <>
            <Button
              className={style.btn}
              styleType="ghost"
              onClick={this.props.onClose}
            >
              <FormattedMessage id="button.close" />
            </Button>
          </>
        </ModalControls>
      </Modal>
    );
  }
}

export default EmailViewModal;
